import axios from 'axios';

const API = axios.create({baseURL: process.env.REACT_APP_SERVER_URL})
// API.interceptors.request.use((req)=>{
//     if(localStorage.getItem('profile'))
//         req.headers.Authorization = `Bearer ${JSON.parse(localStorage.getItem('profile')).token}`

//         return req;
// })
// this function will run like a middleware for other requests


export const auth = (formData) => API.post('/user/oauth2callback',formData, {withCredentials:true})
export const logout = () => API.post('/user/logout','', {withCredentials:true})
export const contactUs = (formData) => API.post("/contact-us", formData);